import React from "react";
import Tooltip from "@charty/tooltip";
import { Locale } from "@linkfluence/models/locale";
import { Platform } from "@linkfluence/models/platform";
import { Timezone } from "@linkfluence/models/timezone";
import { tr } from "@radarly/i18n";
import {
  InfluencerLensFactory,
  SearchableInfluencer,
} from "@radarly/models/influencer/index";
import { SearchFragmentUsers } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";

interface IProps {
  influencer: SearchableInfluencer;
  timezone: Timezone;
  fragment: SearchFragmentUsers;
  locale: Locale;
}

const RadarlyWidgetsTooltipInfluencer = ({
  influencer,
  locale,
  fragment,
  timezone,
}: IProps) => {
  const influencerLens = InfluencerLensFactory.create(influencer.user);

  return (
    <Tooltip
      label={influencerLens.getName()}
      content={
        <span>
          {influencer?.raw_doc_count}{" "}
          {tr(
            locale,
            influencer.user.platform === Platform.Review
              ? "METRICS::REVIEWS"
              : "METRICS::DOC"
          )}
        </span>
      }
      footer={<Date fragment={fragment} timezone={timezone} nowDate={null} />}
    />
  );
};

export default RadarlyWidgetsTooltipInfluencer;
